import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import DataTable from "../../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../../Student/Reusablecomponents/Loading";
import { useSelector, useDispatch } from "react-redux";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { QuestionData } from "../../../Redux/Reducers/QBAdmin/EditQuestions";
import { ScenarioData } from "../../../Redux/Reducers/QBAdmin/Editscenario";
import Search from "../../../ReusableComponents/Search";
import notify from "../../../ReusableComponents/ToastifyAlerts";
import {
  QuestionPreview,
  ViewVerificationQStatus,
  QuestionDelete,
  GetQuestionDetails,
  GetScienceQuestionDetails,
  UpdateHindiQVS,
  ViewQuestionStatus,
} from "../../../ReusableComponents/CommonApis";
import SubHeadersDataTable from "../../../Student/Reusablecomponents/DataTable/SubHeadersDataTable";

import { CheckLanguage } from "../../../ReusableComponents/CommonFunctions";
import { IoMdCloseCircleOutline } from "react-icons/io";
import DropdownValues from "../../../Student/Reusablecomponents/DropDownValues";
import { FaClockRotateLeft } from "react-icons/fa6";
// import localStorage from "redux-persist/es/storage";
const DirectQuestions = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const items = useSelector((state) => state.userDetailsData.LoginDetails);

  const [SearchText, SetSearchText] = useState(localStorage.getItem("SearchQid") || "");
  const [DQuestions, SetDQuestions] = useState(props.data);
  const [PageCount, SetPageCount] = useState(10);
  const [CPage, SetCPage] = useState(parseInt(localStorage.getItem("DPageCount")) || 1);
  const [StatusData, SetStatusData] = useState();
  const [DMessage, SetDMessage] = useState();
  const [Load, SetLoad] = useState(false);
  const [PQuestion, SetPQuestion] = useState();
  const [PopupQVS, SetPopupQVS] = useState();
  const [QVSOptions, SetQVSOptions] = useState();
  const [QuestionsData, SetQuestionData] = useState();
  const GetDirectquestions = async (PageNo, test) => {
    SetCPage(PageNo);
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/QuestionBank/GetNonScenarioQuestions?SubjectId=${items?.subjectId
        }&pageno=${PageNo}&pagesize=${PageCount}&Filter=0&QBCategoryType=NONSCQ&LanguageId=${SelectLanguage}&TopicId=${location.state?.Topic || 0
        }`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetDQuestions(res.data);
        SetLoad((prev) => !prev);
        SetDMessage();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const GetQVStatus = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=45&ParentLovId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.lovDescription,
          value: item.lovId,
        }));
        SetQVSOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetQVStatus();
    if (localStorage.getItem("SearchQid")) {
      GetsearchQuestion();
    } else
      if (!props.data) {
        GetDirectquestions(CPage);
      } else if (DMessage) {
        props.Filtersfunction();
      }
  }, [PageCount, DMessage, SelectLanguage, location.state?.Topic]);
  const HandleQuestionDetails = (Qid) => {
    localStorage.setItem("DPageCount", CPage);
    if (SearchText?.length > 0) {
      localStorage.setItem("SearchQid", SearchText);
    }
    if (items.subjectId === "1") {
      GetQuestionDetails(
        SelectLanguage,
        Qid,
        dispatch,
        navigate,
        SetLoad,
        location,
        true
      );
    } else {
      GetScienceQuestionDetails(
        SelectLanguage,
        Qid,
        dispatch,
        navigate,
        SetLoad,
        location,
        true
      );
    }
  };

  const columns = [
    {
      name: "Question No(Id)",
      sortable: true,
      cell: (row) => (
        <>
          <div
            className="LinkStyles"
            title="Edit Question"
            onClick={() => HandleQuestionDetails(row.questionID)}
          >
            {row.questionID}
          </div>
        </>
      ),
    },
    {
      name: "Question",
      selector: "question",
      cell: (row) => (
        <div className="ScenarioList">
          {CheckLanguage(SelectLanguage) && (
            <div
              className="dflex LinkStyles"
              onClick={() => {
                SetPQuestion(row);
                SetPopupQVS(row.qvsAlt);
              }}
              style={{ justifyContent: "end" }}
            >
              Review & Update Status
            </div>
          )}

          <ScenarioQuestionformat scenario={row.question} />
          {row.qType !== "D" &&
            ["A", "B", "C", "D"].map((option, i) => (
              <>
               {row?.[`option${option}`] && 
              <div
                key={i}
                className="Options"
                style={
                  option === row.answer
                    ? { color: "green", fontWeight: "bold" }
                    : {} 
                }
              >
                <span className="dflex p-1">
                  {" "}
                  {option})&nbsp;{" "}
                  <ScenarioQuestionformat scenario={row[`option${option}`]} />{" "}
                </span>
              </div>}
              </>
            ))}
        </div>
      ),
    },
    {
      name: "Answer(s)",
      selector: "option",
      sortable: true,
      cell: (row) => (
        <div className="dflex">
          {row.qType === "D" ? (
            <ScenarioQuestionformat scenario={row.answer} />
          ) : (
            <span className="dflex p-1">
              {" "}
              {row.answer}) &nbsp;{" "}
              <ScenarioQuestionformat scenario={row[`option${row.answer}`]} />{" "}
            </span>
          )}
        </div>
      ),
    },

    {
      name: "Question Verification Status",
      subColumns: [
        ...(!CheckLanguage(SelectLanguage)
          ? [
            {
              name: "English",
              cell: (row) => (
                <div className="dflex flexd-column">
                  {" "}
                  {row.qbStatus}
                  <span
                    className="LinkStyles"
                    style={{ textWrap: "nowrap" }}
                    onClick={() => SetStatusData(row.questionID)}
                  >
                    View Log{" "}
                  </span>
                </div>
              ),
            },
          ]
          : []),
        ...(!props.data
          ? [
            {
              name: "Hindi",
              selector: "qbStatusALT",
              sortable: true,
              cell: (row) => (
                <>
                  {CheckLanguage(SelectLanguage) ? (
                    <div className="dflex flexd-column">
                      {row.qbStatus}
                      <span
                        className="LinkStyles"
                        style={{ textWrap: "nowrap" }}
                        onClick={() => SetStatusData(row.questionID)}
                      >
                        View Log{" "}
                      </span>
                    </div>
                  ) : (
                    <div>{row.qbStatusALT}</div>
                  )}
                </>
              ),
            },
          ]
          : []),
      ],
    },
    {
      name: "Used/Unused - Mapped/UnMapped",
      selector: "qStatus",
      sortable: true,
    },
    ...(items?.subjectId === "1"
      ? [
        {
          name: "Clone / Original",
          selector: "isClonedOrOriginal",
          sortable: true,
        },
      ]
      : []),
    {
      name: "Action",
      cell: (row) => (
        <div
          className="dflex CPointer alignitems"
          style={{ gap: "15px", justifyContent: "center" }}
        >
          <FaRegEye
            title="Preview"
            onClick={() => {
              localStorage.setItem("DPageCount", CPage);
              if (SearchText?.length > 0) {
                localStorage.setItem("SearchQid", SearchText);
              }
              QuestionPreview(row, dispatch, navigate, location, true);
            }}
          />
          {!CheckLanguage(SelectLanguage) && (
            <RiDeleteBin5Line
              title="Delete"
              style={{ color: "#FD3333" }}
              onClick={() =>
                QuestionDelete(row.questionID, SetDMessage, dispatch)
              }
            />
          )}
          <span
            className="LinkStyles"
            style={{ textWrap: "nowrap" }}
            onClick={() => SetQuestionData(row.questionID)}
            title="View Question Activity Log"
          >
            <FaClockRotateLeft />
          </span>
        </div>
      ),
    },
  ];
  const DAUQuestions = () => {
    dispatch(QuestionData({ QuestionDetails: "" }));
    navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
      state: { Tab: location.state?.Tab },
    });
    dispatch(ScenarioData({ ScenarioDetails: "" }));
  };

  const BacktoNormaList = () => {
    localStorage.removeItem("SearchQid");
    SetSearchText([]);
    GetDirectquestions(CPage);
  };
  const GetsearchQuestion = async () => {
    if (SearchText.length > 0) {
      SetLoad((prev) => !prev);
      await axios
        .get(
          process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetFilterQuestionByQuestionId?QuestionId=${SearchText}&SubjectId=${items?.subjectId}&LanguageId=${SelectLanguage} `,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          SetDQuestions(res.data);
          SetLoad((prev) => !prev);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      notify("Please enter the atlest one Question Id", "warning");
    }
  };
  return (
    <>
      {!props.data && (
        <>
          <div className="MainHeading">Direct Questions</div>
          <div className="Card mt-2">
            <div className="dflex JSBetween alignitems InputFIlters m-1">
              <label style={{ backgroundColor: "white" }}>Search</label>

              <div>By Question Id(s) </div>

              <Search
                onChange={(e) => SetSearchText(e.replace(/[^0-9,]/g, ""))}
                Searchvalue={SearchText}
                placeholder="Enter Question Id(s)"
              />

              <div className="dflex alignitems" style={{ gap: "5px" }}>
                <button className="Buttons" onClick={GetsearchQuestion}>
                  Go
                </button>
                <button className="Buttons" onClick={BacktoNormaList}>
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="dflex mt-3 mb-2 alignitems JSBetween">
        <div className="SubHeading">Questions</div>
        {CheckLanguage(parseInt(SelectLanguage)) ? (
          <div></div>
        ) : (
          <button className="Buttons AddButton dflex alignitems JCCenter" onClick={DAUQuestions}>
            <HiMiniPlusSmall /> Add Question
          </button>
        )}
      </div>
      <div className="Card">
        {DQuestions && (
          <SubHeadersDataTable
            data={DQuestions}
            columns={columns}
            className="NCLDataTable"
            Dropdownvalues={["10", "25", "50", "100"]}
            TotalRecords={props.data ? "" : DQuestions?.[0]?.totalQuestions}
            CountPage={SetPageCount}
            NoPage={props.data ? "" : CPage}
            ShowPagination="true"
            DisplaySearch="ture"
            ShowPagecount="true"
            hitapi={props.data ? "" : GetDirectquestions}
          />

          // <DataTable
          //   data={DQuestions}
          //   columns={columns}
          //   className="NCLDataTable"
          //   Dropdownvalues={["10", "25", "50", "100"]}
          //   TotalRecords={props.data ? "" : DQuestions?.[0]?.totalQuestions}
          //   CountPage={SetPageCount}
          //   NoPage={props.data ? "" : CPage}
          //   ShowPagination="true"
          //   ShowPagecount="true"
          //   hitapi={props.data ? "" : GetDirectquestions}
          // />
        )}
      </div>
      {StatusData && (
        <ViewVerificationQStatus QId={StatusData} Close={SetStatusData} />
      )}
      {QuestionsData && (
        <ViewQuestionStatus QId={QuestionsData} Close={SetQuestionData} />
      )}
      {DMessage?.open && (
        <div className="Model-Open">
          <div className="Card w-50">
            {" "}
            {DMessage?.message}
            <button
              className="Buttons bg-danger"
              style={{ float: "right" }}
              onClick={() => {
                SetDMessage({ open: false });
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {PQuestion && (
        <div className="Model-Open">
          <div
            className="Card"
            style={{ minWidth: "50%", paddingRight: "20px" }}
          >
            <div className="dflex JSBetween mb-2 alignitems ">
              <div></div>

              <IoMdCloseCircleOutline
                className="CPointer"
                onClick={() => {
                  SetPQuestion("");
                  if (PopupQVS !== PQuestion?.qvsAlt) {
                    GetDirectquestions(CPage);
                  }
                }}
              />
            </div>
            <div className="MainHeading mb-2">
              Review and Update Question Verification Status(
              {PQuestion.questionID}):
            </div>
            <div className="dflex JSBetween mb-2">
              <div></div>
              <div>
                {CheckLanguage(SelectLanguage) && (
                  <DropdownValues
                    className="NCLDropdown mb-1"
                    options={QVSOptions}
                    selectoption={PopupQVS}
                    labelname={
                      <div className="DropdownHeader"> Update Status: </div>
                    }
                    onChange={(e) => {
                      SetPopupQVS(parseInt(e.target.value));
                      UpdateHindiQVS(
                        PQuestion.questionID,
                        parseInt(e.target.value),
                        items?.userId,
                        SetLoad,
                        dispatch
                      );
                    }}
                  />
                )}
              </div>
            </div>
            <div
              className=" "
              style={{ display: "grid", gridTemplateColumns: "1fr 0fr 1fr" }}
            >
              <div>
                <div className="SubHeading mb-3">
                  Question (in{" "}
                  {CheckLanguage(SelectLanguage) ? "Hindi" : "English"})
                </div>

                <ScenarioQuestionformat scenario={PQuestion.question} />
                {PQuestion.qType !== "D" ? (
                  ["A", "B", "C", "D"].map((option, i) => (
                    <div
                      key={i}
                      className="Options"
                      style={
                        option === PQuestion.answer
                          ? { color: "green", fontWeight: "bold" }
                          : {}
                      }
                    >
                      <span className="dflex p-1">
                        {" "}
                        {option})&nbsp;{" "}
                        <ScenarioQuestionformat
                          scenario={PQuestion[`option${option}`]}
                        />{" "}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="dflex">
                    <b>Answer :- </b>{" "}
                    <ScenarioQuestionformat scenario={PQuestion.answerAlt} />
                  </div>
                )}
              </div>
              <div
                className="vertical-line"
                style={{ borderLeft: "2px solid #ccc", margin: "5px 10px" }}
              ></div>
              <div>
                <div className="SubHeading mb-3">
                  Question (in{" "}
                  {!CheckLanguage(SelectLanguage) ? "Hindi" : "English"})
                </div>
                <ScenarioQuestionformat scenario={PQuestion.questionAlt} />
                {PQuestion.qType !== "D" ? (
                  ["A", "B", "C", "D"].map((option, i) => (
                    <div
                      key={i}
                      className="Options"
                      style={
                        option === PQuestion.answer
                          ? { color: "green", fontWeight: "bold" }
                          : {}
                      }
                    >
                      <span className="dflex p-1">
                        {" "}
                        {option})&nbsp;{" "}
                        <ScenarioQuestionformat
                          scenario={PQuestion[`option${option}Alt`]}
                        />{" "}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="dflex">
                    <b>Answer :- </b>{" "}
                    <ScenarioQuestionformat scenario={PQuestion.answerAlt} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {Load && <Loading />}
    </>
  );
};
export default DirectQuestions;
